import { Select } from '@zillow/constellation';
import PropTypes from 'prop-types';
import withLabel from './withLabel';

const SelectField = ({ options, name, register, registerProps, error, ...props }) => (
    <>
        <Select {...props} error={!!error} {...register(name, registerProps)}>
            {options.map(({ label, value }) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </Select>
    </>
);

SelectField.propTypes = {
    options: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    register: PropTypes.func,
    registerProps: PropTypes.object,
    error: PropTypes.object,
};

SelectField.defaultProps = {
    registerProps: {},
    register: () => {},
};

const LabeledSelectField = withLabel(SelectField);

export default LabeledSelectField;
